import { render, staticRenderFns } from "./TheSnackbar.vue?vue&type=template&id=a6d8a462&scoped=true&lang=pug&"
import script from "./TheSnackbar.vue?vue&type=script&lang=js&"
export * from "./TheSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./TheSnackbar.vue?vue&type=style&index=0&id=a6d8a462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d8a462",
  null
  
)

export default component.exports